import { t } from '../helpers/translation';
import { BaggageType } from '../interfaces/baggage';
import {
    FlightBaggage,
    FlightBaggageType,
    IncludedBaggageInfo,
} from '@/api/MyBooking/myBooking.interfaces';
import { getBaggageDisplayKey } from './baggage';

export function getBookingIncludedBaggageLabel(
    bag: IncludedBaggageInfo,
    baggageType: BaggageType,
    showType?: boolean
): string {
    if (!bag) {
        return '';
    }

    const labelWeight = t({ key: 'shared.weight' });
    const labelPiece = t({ key: 'shared.piece_suffix' });

    const labelBag = showType !== false ? t({ key: getBaggageDisplayKey(baggageType) }) : '';

    let str = '';
    const { totalWeight, pieces } = bag;

    if (pieces && totalWeight) {
        const weightPerPiece = totalWeight / pieces;
        str = `${pieces} x ${weightPerPiece} ${labelWeight} ${labelBag}`;
    }
    // If only pieces value
    else if (pieces && !totalWeight) {
        str = `${pieces} ${labelPiece} ${labelBag}`;
    }
    // If only weight value
    else if (!pieces && totalWeight) {
        str = ` ${totalWeight} ${labelWeight} ${labelBag}`;
    }

    return str;
}

export function getBookingBaggageLabel(bag: FlightBaggage): string {
    if (!bag) {
        return '';
    }

    const labelWeight = t({ key: 'shared.weight' });
    const labelPiece = t({ key: 'shared.piece_suffix' });
    const labelBag = t({ key: getBookingBaggageDisplayKey(bag.type) });

    let str = '';
    const { weight, pieces } = bag;

    if (pieces && weight) {
        str = `${pieces} x ${weight} ${labelWeight} ${labelBag}`;
    }
    // If only pieces value
    else if (pieces && !weight) {
        str = `${pieces} ${labelPiece} ${labelBag}`;
    }
    // If only weight value
    else if (!pieces && weight) {
        str = `${weight} ${labelWeight} ${labelBag}`;
    }
    // If no pieces and no weight but bag is included
    else if (!pieces && !weight && labelBag) {
        str = `${labelBag}`;
    }

    // Quickfix: outbound/inbound match
    const isOutboundMatch = (bag.description ?? '').includes('OBO');
    const isInboundMatch = (bag.description ?? '').includes('IBO');
    if (isOutboundMatch || isInboundMatch) {
        const key = isOutboundMatch ? 'shared.outbound_flight' : 'shared.homebound';
        str += ` (${t({ key })})`;
    }

    return str;
}

function getBookingBaggageDisplayKey(type: FlightBaggageType): string {
    switch (type) {
        case FlightBaggageType.CabinBag:
            return 'shared.hand_baggage_title';
        case FlightBaggageType.CheckedBag:
            return 'shared.checked_baggage_title';
        default:
            return 'shared.baggage';
    }
}

export function getBookingBaggageIcon(type: FlightBaggageType) {
    switch (type) {
        case FlightBaggageType.SmallBag:
            return 'SmallBag';
        case FlightBaggageType.CabinBag:
            return 'CabinBag';
        case FlightBaggageType.CheckedBag:
            return 'CheckedBag';
        default:
            return null;
    }
}
